<div [attr.shimmer-id]="shimmerFor" class="shimmer"
  [ngStyle]="{ width: loaderWidth, height: loaderHeight, maxWidth: loaderMaxWidth }"
  [ngClass]="{'shimmer-rounded': rounded}"></div>
